import React from 'react';
import { useFormikContext, Field } from 'formik';
import { Button, ResponseErrorMessage, StyledLoginForm, FormField, FormLabel, FormFieldsGrid, FormFooter } from '@app.shared/Style/Forms';
import { FieldValidationMessage } from '@app.shared/Forms';

export const LoginForm = (props) => {
  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting } = useFormikContext();
  const { loginError } = props;
  return (
    <StyledLoginForm>
      {loginError && <ResponseErrorMessage>{loginError}</ResponseErrorMessage>}
      <FormFieldsGrid>
        <FormField>
          <FormLabel>
            <span>
              Email Address <small>*</small>
            </span>
            <Field type="email" name="email" placeholder="Email" />
            <FieldValidationMessage errors={errors} touched={touched} name="email" />
          </FormLabel>
        </FormField>
        <FormField>
          <FormLabel>
            <span>
              Password <small>*</small>
            </span>
            <Field type="password" name="password" placeholder="Password" />
            <FieldValidationMessage errors={errors} touched={touched} name="password" />
          </FormLabel>
        </FormField>
      </FormFieldsGrid>
      <FormFooter>
        <div className="notes">
          <p>{/* Forgot your password, <a href="#">click here</a> to recover it. */}</p>
        </div>
        <div className="actions">
          <Button type="submit" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Logging in...' : 'Login'}
          </Button>
        </div>
      </FormFooter>
    </StyledLoginForm>
  );
};
